/**
 * Previa em formato de celular, no app NATIVO de mensagens (nao e' WhatsApp):
 * moldura de aparelho, barra de status, cabecalho com o remetente e o balao
 * cinza de SMS recebido.
 *
 * O texto chega ja' expandido ({empresa}, {nome} e o link em linha propria) —
 * a previa mostra exatamente o que o cliente vai ler.
 */
export default function PreviewSMS({ texto, remetente }) {
  const agora = new Date();
  const hora = `${String(agora.getHours()).padStart(2, "0")}:${String(agora.getMinutes()).padStart(2, "0")}`;

  return (
    <div className="rounded-xl border bg-card p-5 h-full flex flex-col">
      <h3 className="font-semibold mb-1">Prévia</h3>
      <p className="text-xs text-muted-foreground mb-4">Como chega no app de mensagens</p>

      <div className="flex-1 flex items-center">
      <div className="mx-auto w-full max-w-[260px] rounded-[2rem] border-4 border-muted bg-background shadow-lg overflow-hidden">
        {/* barra de status */}
        <div className="flex items-center justify-between px-5 pt-2.5 pb-1 text-[10px] text-muted-foreground tabular-nums">
          <span>{hora}</span>
          <span className="flex items-center gap-1">
            <span className="inline-block w-3 h-2 rounded-[2px] border border-muted-foreground/60" />
            <span className="inline-block w-1 h-2 rounded-[1px] bg-muted-foreground/60" />
          </span>
        </div>

        {/* cabecalho do app de mensagens */}
        <div className="flex flex-col items-center gap-1 border-b px-4 pb-2.5 pt-1">
          <span className="grid place-items-center w-9 h-9 rounded-full bg-muted text-sm font-semibold text-muted-foreground">
            {(remetente || "S")[0].toUpperCase()}
          </span>
          <p className="text-[11px] font-medium truncate max-w-full">{remetente || "SMS"}</p>
        </div>

        {/* conversa */}
        <div className="px-3 py-4 min-h-[170px] bg-muted/20">
          {texto ? (
            <div>
              <p className="text-[10px] text-muted-foreground text-center mb-2">Hoje {hora}</p>
              <div className="rounded-2xl rounded-bl-sm bg-muted px-3 py-2 max-w-[88%]">
                <p className="text-[12px] leading-snug whitespace-pre-wrap break-words">{texto}</p>
              </div>
            </div>
          ) : (
            <p className="text-[11px] text-muted-foreground text-center pt-14">
              Escreva a mensagem para ver a prévia.
            </p>
          )}
        </div>

        {/* campo de resposta decorativo */}
        <div className="border-t px-3 py-2">
          <div className="rounded-full border bg-background px-3 py-1 text-[10px] text-muted-foreground">
            Mensagem de texto
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
